/**
 * App Entry Point
 * ===============
 * Order matters:
 *   1. Inject CSS variables (theme tokens → :root)
 *   2. Mount React app
 *
 * CSS variables must be injected BEFORE React renders so components
 * that read var(--color-primary) etc. always find them.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { injectCSSVariables } from "@/theme/css";
import { App } from "./App";
import "./index.css";

// Step 1: Theme first
injectCSSVariables();

// Step 2: React
const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
